import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function CodeInjection() {
  const [headerCode, setHeaderCode] = useState("");
  const [footerCode, setFooterCode] = useState("");

  useEffect(() => {
    const fetchCodeInjection = async () => {
      try {
        const { data, error } = await supabase
          .from("site_settings")
          .select("key, value")
          .in("key", ["header_code_injection", "footer_code_injection"]);

        if (error) throw error;

        data?.forEach((setting) => {
          if (setting.key === "header_code_injection" && setting.value) {
            setHeaderCode(setting.value);
          } else if (setting.key === "footer_code_injection" && setting.value) {
            setFooterCode(setting.value);
          }
        });
      } catch (error) {
        console.error("Error fetching code injection:", error);
      }
    };

    fetchCodeInjection();
  }, []);

  useEffect(() => {
    // Inject footer code
    if (footerCode) {
      const existingContainer = document.getElementById(
        "footer-code-injection",
      );
      if (existingContainer) {
        existingContainer.remove();
      }

      const container = document.createElement("div");
      container.id = "footer-code-injection";
      container.innerHTML = footerCode;
      document.body.appendChild(container);

      // Execute any scripts in the footer code
      const scripts = container.querySelectorAll("script");
      scripts.forEach((oldScript) => {
        const newScript = document.createElement("script");
        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent;
        oldScript.parentNode?.replaceChild(newScript, oldScript);
      });

      return () => {
        const containerToRemove = document.getElementById(
          "footer-code-injection",
        );
        if (containerToRemove) {
          containerToRemove.remove();
        }
      };
    }
    return undefined;
  }, [footerCode]);

  useEffect(() => {
    // Header code is injected straight into <head>. Helmet is NOT used here:
    // it does not render into the SSR stream in TanStack Start, so anything
    // declared with it never reaches the document.
    if (!headerCode) return undefined;

    const container = document.createElement("div");
    container.innerHTML = headerCode;
    const injected: Element[] = [];

    Array.from(container.children).forEach((el) => {
      let node: Element;
      if (el.tagName === "SCRIPT") {
        const script = document.createElement("script");
        Array.from(el.attributes).forEach((attr) => {
          script.setAttribute(attr.name, attr.value);
        });
        script.textContent = el.textContent;
        node = script;
      } else {
        node = el.cloneNode(true) as Element;
      }
      node.setAttribute("data-header-code-injection", "");
      document.head.appendChild(node);
      injected.push(node);
    });

    return () => {
      injected.forEach((node) => node.remove());
    };
  }, [headerCode]);

  return null;
}
